import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

import type { CalendarEvent, Course, Path } from 'shared-types';

interface Props {
  calendarEvent?: Pick<CalendarEvent, 'id' | 'title'>;
  course?: Pick<Course, 'id' | 'title'>;
  path?: Pick<Path, 'id' | 'title'>;
  templateId: number;
  updateTemplates: () => void;
}

const CertificatesProductItem = ({
  calendarEvent,
  course,
  path,
  templateId,
  updateTemplates
}: Props) => {
  const { messages, theme } = useReduxState();

  const remove = async () => {
    if (course) {
      await api.delete(
        `/admin/certificate-templates/${templateId}/courses/${course.id}`
      );
    } else if (path) {
      await api.delete(
        `/admin/certificate-templates/${templateId}/paths/${path.id}`
      );
    } else {
      await api.delete(
        `/admin/certificate-templates/${templateId}/calendar-events/${calendarEvent.id}`
      );
    }

    await updateTemplates();
    return true;
  };

  return (
    <div className="content">
      {course ? course.title : path ? path.title : calendarEvent.title}

      <div className="remove">
        <ConfirmButton
          actionText={messages.commonRemove}
          buttonIcon="times"
          buttonSize="small"
          category="danger"
          confirmText={
            course
              ? messages.siteCertificatesRemoveCourseConfirm
              : path
              ? messages.commonRemovePathConfirm
              : messages.commonRemoveCalendarEventConfirm
          }
          confirmTitle={
            course
              ? messages.commonRemoveCourse
              : path
              ? messages.commonRemovePath
              : messages.commonRemoveCalendarEvent
          }
          onConfirm={remove}
          successMessage={
            course
              ? messages.commonRemoveCourseSuccess
              : path
              ? messages.commonRemovePathSuccess
              : messages.commonRemoveCalendarEventSuccess
          }
          stopPropagation={true}
        />
      </div>

      <style jsx>{`
        .content {
          background-color: ${theme.lightGrey};
          border-radius: 4px;
          display: inline-block;
          font-size: 1.3rem;
          padding: 2px 25px 3px 7px;
          position: relative;
        }
        .remove {
          position: absolute;
          right: 2px;
          top: 2px;
        }
        .remove :global(button) {
          background-color: transparent;
          color: ${theme.textColorLight};
          padding: 2px;
          height: 18px;
          width: 18px;
        }
        .remove :global(button:hover) {
          background-color: ${theme.lightGreyActive};
          color: ${theme.textColorLight};
        }
      `}</style>
    </div>
  );
};

export default CertificatesProductItem;
